import { render, staticRenderFns } from "./PurchaseInvoicesLinesTable.vue?vue&type=template&id=85ae4608&scoped=true&"
import script from "./PurchaseInvoicesLinesTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesLinesTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoicesLinesTable.vue?vue&type=style&index=0&id=85ae4608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ae4608",
  null
  
)

export default component.exports